import React from "react";
import { youtube_v3 } from "googleapis";
import { IconBrandYoutube } from "@tabler/icons-react";
import moment from "moment";
import { formatCount, formatDuration } from "../../utils/youtubeUtils";

interface VideoGridProps {
  videos: youtube_v3.Schema$Video[];
  selectedVideoId: string | null;
  onSelectVideo: (video: youtube_v3.Schema$Video) => void;
}

const VideoGrid: React.FC<VideoGridProps> = ({
  videos,
  selectedVideoId,
  onSelectVideo,
}) => {
  return (
    <div className="py-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {videos.map((video) => (
        <div
          key={video.id}
          className={`cursor-pointer rounded-lg overflow-hidden border ${
            selectedVideoId === video.id ? "border-red-500" : "border-gray-700"
          }`}
          onClick={() => onSelectVideo(video)}
        >
          <div className="relative">
            {video.snippet?.thumbnails?.medium?.url ? (
              <img
                src={video.snippet.thumbnails.medium.url}
                alt={video.snippet?.title || "Video thumbnail"}
                className="w-full aspect-video object-cover"
              />
            ) : (
              <div className="w-full aspect-video bg-gray-800 flex items-center justify-center">
                <IconBrandYoutube size={40} className="text-red-500" />
              </div>
            )}

            <div className="absolute bottom-2 right-2 bg-black bg-opacity-80 text-white text-xs px-1 rounded">
              {video.contentDetails?.duration
                ? formatDuration(video.contentDetails.duration)
                : "N/A"}
            </div>
          </div>

          <div className="p-3">
            <h3 className="text-sm font-semibold line-clamp-2 h-10">
              {video.snippet?.title}
            </h3>
            <div className="flex items-center justify-between mt-2 text-xs text-gray-400">
              <span>
                {video.statistics?.viewCount
                  ? `${formatCount(parseInt(video.statistics.viewCount))} views`
                  : "N/A"}
              </span>
              <span>
                {video.snippet?.publishedAt
                  ? moment(video.snippet.publishedAt).fromNow()
                  : "N/A"}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VideoGrid;
